/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum unit_option_categories {
  GENERIC = 'Generic',
  GENERAL = 'General',
  BSB = 'BSB',
  EXTRA_SPELLS = 'ExtraSpells',
  MOUNT = 'Mount',
  EQUIPMENT = 'Equipment',
  MAGIC_EQUIPMENT = 'MagicEquipment',
  MAGIC_LVL = 'MagicLvl',
  MAGIC_PATH = 'MagicPath',
  M = 'M',
  S = 'S',
  C = 'C',
  MAGIC_BANNER = 'MagicBanner',
  SPECIAL_RULE = 'SpecialRule',
  ONE_CHOICE = 'OneChoice',
  MUST_CHOICE = 'MustChoice',
  WIZARD_APPRENTICE = 'WizardApprentice',
  WIZARD_ADEPT = 'WizardAdept',
  WIZARD_MASTER = 'WizardMaster',
  MAY_TAKE = 'MayTake',
  SPELL = 'Spell',
  MAGIC_ITEM_CATEGORY = 'MagicItemCategory',
  MAGIC_ITEM = 'MagicItem',
  MAGIC_STANDARD = 'MagicStandard',
  UNIT_EQUIPMENT = 'UnitEquipment',
}
